/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".comment[_ngcontent-%COMP%]{padding:8px}.comment-text[_ngcontent-%COMP%]{margin:8px 0 0 16px}"];
export { styles as styles };
